import React from 'react';

const Footer = () => (
  <ul className="mi-socialicons mi-socialicons-bordered"></ul>
);

export default Footer;
